import React, { FC, SVGProps } from "react";

const EndIcon: FC<SVGProps<SVGSVGElement>> = (props) => {
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13.77 4.97998C14.7138 5.92407 15.3564 7.12681 15.6167 8.43612C15.877 9.74543 15.7432 11.1025 15.2322 12.3358C14.7212 13.5691 13.8561 14.6231 12.7461 15.3647C11.6361 16.1063 10.3311 16.5022 8.99622 16.5022C7.66129 16.5022 6.35633 16.1063 5.24635 15.3647C4.13636 14.6231 3.2712 13.5691 2.76024 12.3358C2.24929 11.1025 2.11549 9.74543 2.37576 8.43612C2.63603 7.12681 3.27869 5.92407 4.22247 4.97998"
        stroke={`#${props.color}`}
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M9 1.5V9" stroke={`#${props.color}`} strokeWidth="1.2" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default EndIcon;
